import { ErrorBoundary, Fallback, Loader, Toast } from "@sicredi/react";
import React from "react";
import { render, unmountComponentAtNode } from "react-dom";

/* Descomentar caso utilize a autenticação da plataforma. Remover se utilizar a do CAS */
/*import {
  createEmployeeOpenIdClient,
  createSalesForceEmployeeOpenIdClient,
} from "@sicredi/authentication";
import { APPLICATION } from "#/constants";*/

import { startApiMockServer } from "#/api/server";
import App from "#/containers/App";
import { onResponse } from "#/utils/request";
import "./global.scss";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { version } from "./version";

const ROOT = document.getElementById("root")!;

function unmountRender(element: React.ReactElement) {
  unmountComponentAtNode(ROOT);
  render(element, ROOT);
}

unmountRender(<Loader show fullScreen />);

if (!!process.env.REACT_APP_MIRAGE && process.env.REACT_APP_MIRAGE === "true") {
  startApiMockServer({});
}

onResponse((response) => {
  function handleClose() {
    window.auth.actions.logout();
    window.location.reload();
  }

  if (response?.status === 401) {
    unmountRender(
      <Fallback title="Acesso negado" onClose={handleClose}>
        Você não possui autorização para acessar essa aplicação.
      </Fallback>
    );
  }
});

/* FAKE AUTH - Alterar quando adicionado autenticação plataforma/CAS */
const authentication = {
  async authenticate() {
    return {};
  },
  getJwtIdToken() {
    return { payload: "user" };
  },
  getAccessToken() {
    const tokensStorage = JSON.parse(
      sessionStorage.getItem("oidc.default") || ""
    );

    const token = tokensStorage?.tokens?.accessToken;
    return token;
  },

  logout() {
    return {};
  },
};

authentication
  .authenticate()
  .then((auth) => {
    window.appVersion = version;

    window.auth = {
      ...auth,
      user: authentication.getJwtIdToken()!.payload,
      get token() {
        return authentication.getAccessToken();
      },
      actions: {
        logout: authentication.logout.bind(authentication),
      },
    };

    unmountRender(
      <ErrorBoundary>
        <Toast />
        <App />
      </ErrorBoundary>
    );
  })
  .catch((err) => {
    if (err?.status && err?.status !== "URL_NOT_VERIFIED") {
      unmountRender(<Fallback />);
    }
  });

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();
